export const USER_MULTI_OPTIONS = {
	SITE: "site",
	OFFICE: "office",
	MASTERS: "master",
}